
document.addEventListener('DOMContentLoaded', () => {
    const localizationBlocks = document.querySelectorAll('.localization')
    if (localizationBlocks)
        localizationBlocks.forEach(localization => {
            var swiperElement = localization.querySelector('.swiper');
            var swiper = new Swiper(swiperElement, {
                // loop: 1,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                autoplay: {
                    delay: 3000,
                },
                navigation: {
                    prevEl: swiperElement.querySelector(`.swiper-prev`),
                    nextEl: swiperElement.querySelector(`.swiper-next`),
                },
            });
        })

    const slidersBlocks = document.querySelectorAll('.sliders')
    if (slidersBlocks)
        slidersBlocks.forEach(sliderBlock => {
            var slidersInBlock = sliderBlock.querySelectorAll('.sliders__box')
            slidersInBlock.forEach(slider => {
                var sliderElement = slider.querySelector('.swiper')
                var swiperSlider = new Swiper(sliderElement, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    speed: 1000,
                    autoplay: {
                        delay: 3000,
                    },
                    navigation: {
                        prevEl: slider.querySelector(`.swiper-prev`),
                        nextEl: slider.querySelector(`.swiper-next`),
                    },
                })
            })

        })

    const interiorsBlocks = document.querySelectorAll('.interiors')
    if (interiorsBlocks)
        interiorsBlocks.forEach(interiorBlock => {
            var slidersInBlock = interiorBlock.querySelectorAll('.interiors__slider')
            slidersInBlock.forEach(sliderElement => {
                var swiperElement = sliderElement.querySelector('.swiper')
                var swiperSlider = new Swiper(swiperElement, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    speed: 1000,
                    autoplay: {
                        delay: 3000,
                    },
                    navigation: {
                        prevEl: sliderElement.querySelector(`.swiper-prev`),
                        nextEl: sliderElement.querySelector(`.swiper-next`),
                    },
                })

            });
        })



    const sliderWithThumbnailsBlocks = document.querySelectorAll('.sliderThumbnails')
    if (sliderWithThumbnailsBlocks)
        sliderWithThumbnailsBlocks.forEach(sliderWithThumbnailsBlock => {
            var mainSwiper = sliderWithThumbnailsBlock.querySelector('.mainSwiper')
            var thumbsSwiper = sliderWithThumbnailsBlock.querySelector('.thumbsSwiper')

            var galleryThumbs = new Swiper(thumbsSwiper, {
                centeredSlides: true,
                centeredSlidesBounds: true,
                slidesPerView: 3,
                spaceBetween: 10,
                watchOverflow: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                direction: 'vertical'
            });

            var galleryMain = new Swiper(mainSwiper, {
                watchOverflow: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,
                navigation: {
                    nextEl: mainSwiper.querySelector('.swiper-next'),
                    prevEl: mainSwiper.querySelector('.swiper-prev'),
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            });

            galleryMain.on('slideChangeTransitionStart', function () {
                galleryThumbs.slideTo(galleryMain.activeIndex);
            });

            // galleryThumbs.on('transitionStart', function () {
            //     galleryMain.slideTo(galleryThumbs.activeIndex);
            // });


        })






})